module.exports = __webpack_public_path__ + "6f1520d.ttf";